import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { Box } from '@mui/material';
import moment from 'moment';
import Slider from "react-slick";

import { apiCallV2 } from '../../../utils/api'
import CustomActionButton from '../../../common/CustomActionButton';
import CustomButton from '../../../common/CustomButton';
import EditAmbassadorForm from './EditAmbassadorForm';
import { RemoveAmbassador } from '../../../redux/ambassador/actions';
import toast from 'react-hot-toast';
import { delay } from '../../../utils';

const EditAmbassador = (props) => {
    const { user, setShow } = props;
    const [buttonStatus, setButtonStatus] = useState('action')
    const [selectedOption, setSelectedOption] = useState("");
    const sliderRef = useRef(null);
    const [page, setPage] = useState(0);
    const settings = {
        rows: 1,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        swipeToSlide: true,
        swipe: false,
        arrows: false,
        draggable: false,
        initialSlide: page,
        adaptiveHeight: true,
    };
    const SlideTo = (p) => {
        sliderRef?.current?.slickGoTo(p);
    }

    const handleConfirm = async () => {

    }

    useEffect(() => {
        sliderRef?.current?.slickGoTo(0);
    }, [user]);

    return (
        <div id="edit-ambassador-form">
            <Box sx={{ mb: '30px' }}>
                <div id="eambf-header">
                    <p>{(user?.first_name + " " + user?.last_name + " " + (user?.dob ? ` - DOB: ${moment(user?.dob).format("LL")}` : ""))}</p>
                    <p>{user?.name || "NO COMPANY"}</p>
                </div>

                <div className='slick-custom-container'>
                    <Slider {...settings} ref={sliderRef}>

                        <div>
                            <div id="option-card-list">
                                <div id="option-card" onClick={() => {
                                    setSelectedOption(selectedOption == "remove" ? "" : 'remove');
                                }}>
                                    <div class={"op-indicator " + (selectedOption == "remove" ? "selected" : "")}></div>
                                    <h5>Remove Ambassador</h5>
                                </div>

                                <div id="option-card" onClick={() => {
                                    setSelectedOption(selectedOption == "update" ? "" : 'update');
                                }}>
                                    <div class={"op-indicator " + (selectedOption == "update" ? "selected" : "")}></div>
                                    <h5>Update Ambassador</h5>
                                </div>
                            </div>

                            <div className='edit-amb-action'>
                                {
                                    (selectedOption == "update" || !selectedOption)
                                        ? <CustomButton onClick={() => {
                                            if (selectedOption) {
                                                SlideTo(1);
                                            }
                                        }}>UPDATE</CustomButton>
                                        : <CustomActionButton action={async () => {
                                            const res = await props.RemoveAmbassador(user);
                                            if (res) {
                                                toast.success("Ambassador successfully removed.");
                                                delay(() => {
                                                    setShow(false);
                                                }, 2000);
                                                return true;
                                            } else {
                                                toast.error("Failed to remove ambassador!")
                                                return false;
                                            }
                                        }}>REMOVE</CustomActionButton>
                                }

                            </div>

                        </div>

                        <div>
                            <EditAmbassadorForm user={user} setShow={setShow} SlideTo={SlideTo} />
                        </div>
                    </Slider>
                </div>

            </Box>
        </div>
    );
};

const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps, {
    RemoveAmbassador,
})(EditAmbassador);
